﻿import {useMemo} from "react";
import {isNullOrEmpty, translation} from "@2d-front-monorepo/core";
import {
	useInitializeMvvmContext,
	Message,
	MvvmButton,
	MvvmDataProvider
} from "@2d-front-monorepo/design-library";
import {
	CreateVehicleComponent, CreateVehicleModel, DefaultParkingCategory, PermitsMvvmErrorCollector,
	VehicleId, Vehicles, VehicleType
} from "@2d-front-monorepo/permits-business";

import {PermitTranslations} from "@2d-front-monorepo/shared-translations";

import {JSX, useCallback} from "react";
import {useNavigate, useParams} from "react-router";
import {PermitsBackButton} from "../../components/PermitsBackButton";
import {getGlobalContext} from "../../hooks/getGlobalContext";
import {getHttpClient} from "../../hooks/getHttpClient";
import {ReloadEntities, reloadPermits} from "../../hooks/reloadPermits";
import {usePermits} from "../../hooks/usePermits";
import {PrivateRoutes} from "../../routes";

type EditVehicleModel = CreateVehicleModel & {}

export default function EditVehicle(): JSX.Element {
	const {vehicleId} = useParams<{ vehicleId: string }>() as { vehicleId: VehicleId };
	const navigate = useNavigate();
	const permitsState = usePermits();
	const vehicle = isNullOrEmpty(vehicleId) ? undefined : Vehicles.get(permitsState, vehicleId);
	const {installation} = getGlobalContext();
	const vehicleType = vehicle?.type ?? VehicleType.Resident;

	const configuration = useMemo(() => ({
		name: DefaultParkingCategory,
		attachments: {
			required: [],
			optional: []
		},
		fieldRules: installation.configuration.vehicles.defaultRules
	}), [installation]);

	const addressData = installation.configuration.addressData;
	const vehicleData = installation.configuration.vehicleData;

	const {context} = useInitializeMvvmContext({
		initialState: (): EditVehicleModel => {
			const vehicleData = vehicle?.data;
			return {
				arguments: {
					plate: vehicle?.plate ?? "",
					type: vehicleType,
					data: {
						nickname: vehicleData?.nickname,
						color: vehicleData?.color,
						model: vehicleData?.model,
						type: vehicleData?.type,
						province: vehicleData?.province
					},
					customData: vehicle?.customData ?? [],
					attachments: vehicle?.attachments ?? []
				},
				customData: [],
				attachments: {}
			}
		}
	});

	const onSubmit = useCallback(async (m: EditVehicleModel) => {
		const httpClient = getHttpClient()
		const args = m.arguments.data;

		await httpClient.vehicles.update(vehicleId, {
			nickname: args?.nickname,
			color: args?.color,
			model: args?.model,
			type: args?.type,
			province: args?.province
		});

		await reloadPermits(ReloadEntities.Holder);
		navigate(PrivateRoutes.vehicles);
	}, [navigate]);

	if (vehicle == null) {
		return (<Message title={{text: `Invalid vehicle id: [${vehicleId}]`}} type="error"/>);
	}

	return <MvvmDataProvider<EditVehicleModel> context={context} onSubmit={onSubmit}>
		<h1>{translation(PermitTranslations.vehicles_page__title__edit)}</h1>
		<hr/>
		<PermitsMvvmErrorCollector/>
		<CreateVehicleComponent context={context} configuration={configuration} colors={vehicleData.colors}
		                        models={vehicleData.models} plateValidation={{existing: [], readOnly: true}}
		                        provinces={addressData.provinces}>

		</CreateVehicleComponent>
		<div className="form__buttons form__buttons--bottom">
			<MvvmButton kind="primary">{translation(PermitTranslations.save_changes)}</MvvmButton>
			<span></span>
			<PermitsBackButton/>
		</div>
	</MvvmDataProvider>;
}
